package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.presentation.viewmodel.AuthViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun RegisterScreen(authVm: AuthViewModel, onBackToLogin: () -> Unit, onBack: (() -> Unit)? = null) {
    val state by authVm.state.collectAsState()
    var username by remember { mutableStateOf("") }
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }

    AuthShell("Create account", "Join to start watching", onBack = onBack) {
        ErrorText(state.error)
        Field("Username", username, "choose a username") { username = it; authVm.clearError() }
        Field("Email", email, "you@example.com") { email = it; authVm.clearError() }
        Field("Password", password, "at least 6 characters", password = true) { password = it; authVm.clearError() }
        Div(attrs = { style { property("margin-top", "6px") } }) {
            PrimaryButton(
                text = if (state.isLoading) "Creating…" else "Create account",
                enabled = !state.isLoading && username.isNotBlank() && email.isNotBlank() && password.isNotBlank(),
            ) { authVm.register(username.trim(), email.trim(), password) }
        }
        Div(attrs = {
            style {
                property("margin-top", "16px"); property("text-align", "center")
                property("color", Theme.textDim); property("font-size", "14px")
            }
        }) {
            Text("Already have an account? ")
            A(href = "#", attrs = { onClick { it.preventDefault(); onBackToLogin() } }) { Text("Sign in") }
        }
    }
}
